/**
 * Aanwezigheidskalender — dagtelling-strook (Epic 4, Story 4.2, AC 2/AC 3)
 *
 * "kantoor: N · thuis: N · afwezig: N" per dag, met de dagdeel-basis
 * expliciet zichtbaar (AC 3: N kan een half getal zijn, bijv. "2,5").
 */

import type { AttendanceCalendarResponse } from '@functieloonhuis/shared';
import { tellForDate } from '../utils/telling';
import { formatDateLabel } from '../../werkrooster/utils/dateUtils';

interface AanwezigheidTellingStripProps {
  response: AttendanceCalendarResponse;
  dates: string[];
}

function formatCount(n: number): string {
  // Dagdeel-precisie (AC 3): getallen kunnen een half getal zijn (bijv. 2,5)
  // — expliciet zichtbaar, geen afronding.
  return n.toLocaleString('nl-NL', { minimumFractionDigits: n % 1 === 0 ? 0 : 1, maximumFractionDigits: 1 });
}

export function AanwezigheidTellingStrip({ response, dates }: AanwezigheidTellingStripProps) {
  return (
    <div data-testid="aanwezigheid-telling-strip" className="grid gap-1 px-2 py-2 border-t border-[#E2E8F0] bg-gray-50 text-[11px]" style={{ gridTemplateColumns: `140px repeat(${dates.length}, minmax(70px, 1fr))` }}>
      <div className="text-gray-500 font-medium">Telling (per dagdeel)</div>
      {dates.map((date) => {
        const telling = tellForDate(response, date);
        return (
          <div
            key={date}
            data-testid={`telling-${date}`}
            title={`${formatDateLabel(new Date(`${date}T00:00:00`))}: kantoor ${formatCount(telling.kantoor)}, thuis ${formatCount(telling.thuis)}, afwezig ${formatCount(telling.afwezig)}`}
            className="text-center text-[#1E293B] whitespace-nowrap"
          >
            <span className="text-green-700">kantoor: {formatCount(telling.kantoor)}</span>
            {' · '}
            <span className="text-blue-700">thuis: {formatCount(telling.thuis)}</span>
            {' · '}
            <span className="text-[#2F5A7A]">afwezig: {formatCount(telling.afwezig)}</span>
          </div>
        );
      })}
    </div>
  );
}
